import axios from 'axios';
import REACT_APP_BACK_URL from '../../constants/constants';

const createUserConf = async (
  {
    theme,
    workspaceName,
    pseudo,
  },
) => axios
  .post(
    `${REACT_APP_BACK_URL}/createUserConf`,
    {
      theme,
      workspaceName,
      pseudo,
    },
  );

export default createUserConf;
